import { z } from "zod";
import { apiClient } from "../client";
import { categoryAttributeResponseSchema } from "./schemas";
import type {
  CategoryAttributeResponse,
  CreateCategoryAttributeRequest,
} from "./types";

export async function getCategoryAttributesWithValues(): Promise<
  CategoryAttributeResponse[]
> {
  const response = await apiClient
    .get("category-attributes", {})
    .json<CategoryAttributeResponse[]>();

  return z.array(categoryAttributeResponseSchema).parse(response);
}

export async function getCategoryAttribute(
  id: string | number
): Promise<CategoryAttributeResponse> {
  const response = await apiClient
    .get(`category-attributes/${id}`, {})
    .json<CategoryAttributeResponse>();

  return categoryAttributeResponseSchema.parse(response);
}

export async function createCategoryAttribute(
  data: CreateCategoryAttributeRequest
): Promise<CategoryAttributeResponse> {
  const response = await apiClient
    .post("category-attributes", { json: data })
    .json<CategoryAttributeResponse>();

  return categoryAttributeResponseSchema.parse(response);
}

export async function updateCategoryAttribute(
  id: string | number,
  data: CreateCategoryAttributeRequest
): Promise<CategoryAttributeResponse> {
  const response = await apiClient
    .put(`category-attributes/${id}`, { json: data })
    .json<CategoryAttributeResponse>();

  return categoryAttributeResponseSchema.parse(response);
}

export async function deleteCategoryAttribute(
  id: string | number
): Promise<void> {
  await apiClient.delete(`category-attributes/${id}`, {});
}
